import {
  Box,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material'
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked'
import Lens from '@mui/icons-material/Lens'

export default function StepSector({
  t,
  enterpriseName,
  sectors,
  selectedSector,
  selectedCustomSector,
  handleSectorChange,
  handleCustomSectorChange
}) {

  const allSectorOptions = t('sector', { returnObjects: true })

  const sortedSectorOptions = Object.entries(allSectorOptions)
    .filter(([key]) => key !== 'label')
    .sort(([, a], [, b]) => a.localeCompare(b))

  const isOtherSelected = selectedSector === 'other'

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2} alignItems="start">
        <Grid item xs={12} md={5}>
          <Typography
            component="h3"
            variant="h4"
            sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '42px' } }}
          >
            {t('survey.create.stepper.step2')}
          </Typography>
        </Grid>

        <Grid item xs={12} md={7}>
          <Typography
            sx={{
              display: 'block',
              mt: 1.5,
              fontSize: '15px',
              color: '#0d93d2',
              fontWeight: 800
            }}
          >
            {t('survey.create.stepper.whichCompany')}
          </Typography>

          <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>
            {enterpriseName}
          </Typography>

          <Typography
            sx={{
              fontSize: '22px',
              color: '#0d93d2',
              fontWeight: 600,
              mt: 1,
              mb: 1
            }}
          >
            {t('survey.create.stepper.mainSector')}
          </Typography>

          {!!sectors.length && (
            <>
              <RadioGroup
                aria-label="sectors"
                name="sectors"
                value={selectedSector}
                onChange={handleSectorChange}
                sx={{
                  width: 'fit-content',
                  '& .MuiFormControlLabel-root': {
                    mb: 0.8,
                    alignItems: 'flex-start'
                  },
                  '& .MuiFormControlLabel-label': { lineHeight: 1.8 },
                  '& .MuiRadio-root': {
                    p: 0.25,
                    paddingRight: 1,
                    paddingLeft: 1.3
                  }
                }}
              >
                {sectors
                  .filter(s => s?.sectorCode !== 'EXC')
                  .sort((a, b) => a.sectorCode.localeCompare(b.sectorCode))
                  .map((sector, index) => (
                    <FormControlLabel
                      key={index}
                      value={sector?.sectorCode}
                      control={
                        <Radio
                          size="small"
                          icon={
                            <RadioButtonUnchecked
                              sx={{ fontSize: 21, color: '#58d7ff' }}
                            />
                          }
                          checkedIcon={<Lens sx={{ fontSize: 21 }} />}
                          sx={{ '&.Mui-checked': { color: '#0a93d2' } }}
                        />
                      }
                      label={t(`sector.${sector?.sectorCode}`)}
                    />
                  ))}

                <FormControlLabel
                  value="other"
                  control={
                    <Radio
                      size="small"
                      icon={
                        <RadioButtonUnchecked
                          sx={{ fontSize: 21, color: '#58d7ff' }}
                        />
                      }
                      checkedIcon={<Lens sx={{ fontSize: 21 }} />}
                      sx={{ '&.Mui-checked': { color: '#0a93d2' } }}
                    />
                  }
                  label={t('sector.other')}
                />
              </RadioGroup>

              {isOtherSelected && (
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>{t('sector.label')}</InputLabel>
                  <Select
                    value={selectedCustomSector}
                    onChange={handleCustomSectorChange}
                    label={t('sector.label')}
                  >
                    {sortedSectorOptions.map(([key, label]) => (
                      <MenuItem key={key} value={key}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}